"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LegacyCulture = void 0;
var _internals = require("../internals");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Returns an object containing serialized formatting rules for legacy formatters, e.g. @ori/formatter.
 *
 * @see {@link LegacyCultureProps} for the available props.
 * @deprecated Use \@ori/culture package features to format instead of legacy formatters.
 */
const LegacyCulture = ({
  language,
  culture,
  financialSet
}) => {
  if (!language || !culture || !financialSet) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
    // eslint-disable-next-line react/no-danger -- We don't want the encoded model escaped
    dangerouslySetInnerHTML: {
      __html: JSON.stringify((0, _internals.getLegacyCulture)(language, culture, financialSet))
    },
    id: "culture",
    type: "application/json"
  });
};
exports.LegacyCulture = LegacyCulture;
